import { Injectable } from '@angular/core';
import { ArcService } from './arc.service';
import { Data } from './data';

@Injectable()
export class UtilsService {
  uniqueIdentifiersLs: string[];
  auths;
  data = new Data();

  constructor(private arcs: ArcService) {
    arcs.utils = this;
  }

  saveExport(data, filename, params?: object) {
    let hiddenElement = document.createElement('a');
    if (params && params['raw']) {
      console.log('RAW');
    } else {
      data = JSON.stringify(data);
    }

    hiddenElement.href = URL.createObjectURL(new Blob([data], { type: 'text/plain' }));
    hiddenElement.target = '_blank';
    hiddenElement.download = filename;
    hiddenElement.click();
    hiddenElement.remove();
  }



  get uniqueIdentifier() {
    if (!this.uniqueIdentifiersLs || this.uniqueIdentifiersLs.length < 5) {
      let r = this.arcs.run({
        fun: 'generateUniqueIdentifiers',
      });
      r.subscribe((ls) => this.uniqueIdentifiersLs = ls);
      if (!this.uniqueIdentifiersLs)
        return null;
    }
    return this.uniqueIdentifiersLs.pop();
  }

  get email() {
    return this.auths.email;
  }

  get isAdmin() {
    return this.auths && this.auths.isAdmin;
  }

  get authenticated() {
    if (!this.auths)
      return false;
    return this.auths.authenticated;
  }


  login() {
    this.auths.login();
  }

  logout() {
    this.auths.logout();
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/utils.service.ts